import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createDiscount,
  getDiscountList,
  history,
  getSingleDiscount,
  getLandClassificationsList,
  landClassificationsList,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    discount: '',
    effective_date_from: '',
    discount_from: '',
    discount_to: '',
    actual_use_id: ''
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
    discount: 'required',
    effective_date_from: 'required',
    discount_from: 'required',
    discount_to: 'required',
    actual_use_id: 'required'
  });

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    getLandClassificationsList({isPaginate: 1});

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
      effective_date_from: _.get(formData, 'effective_date_from') ? `${moment(_.get(formData, 'effective_date_from')).format(
        'YYYY-MM-DD HH:mm'
      )}:00` : '',
      // effective_date_to: _.get(formData, 'effective_date_to') ?`${moment(_.get(formData, 'effective_date_to')).format(
      //   'YYYY-MM-DD HH:mm'
      // )}:00` : '',
      discount_from: _.get(formData, 'discount_from') ? moment(_.get(formData, 'discount_from')).format('MM-DD') : '',
      discount_to: _.get(formData, 'discount_to') ? moment(_.get(formData, 'discount_to')).format('MM-DD') : '',
    };
    createDiscount(args, ({ data }) => {
      setModal({ isOpen: false });
      getDiscountList();
      history.push(
        `/rpt/land/land-settings/discounts/${_.get(data, 'id')}`
      );
      getSingleDiscount(data.id);
    });
  };

  const createDropdownLandClass = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
      });
    });
    return newList;
  };

  const handleLandClassSelect = e => {
    setFormData({
      ...formData,
      actual_use_id: e.value,
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Discount Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Discount {validateForm.renderMessage('discount')}
            </label>
            <input
              className="form-control"
              type="text"
              name="discount"
              onChange={onChange}
              value={_.get(formData, 'discount')}
            />
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label className="form-label">Actual Use</label> {validateForm.renderMessage('actual_use_id')}
            <div>
              <Select
                options={createDropdownLandClass(landClassificationsList)}
                styles={customStyle}
                placeholder="Select Actual Use"
                value={createDropdownLandClass(landClassificationsList).filter(item => _.get(formData, 'actual_use_id') === _.get(item, 'value')) || ''}
                onChange={e => {
                  handleLandClassSelect(e);
                }}
              />
            </div>
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext">
              Effectivity From {validateForm.renderMessage('effective_date_from')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('effective_date_from')}
              value={_.get(formData, 'effective_date_from') || ''}
            />
          </div>
          {/* <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext">Effectivity To:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('effective_date_to')}
              value={_.get(formData, 'effective_date_to') || ''}
            />
          </div> */}
          <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext">
              Discount From {validateForm.renderMessage('discount_from')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('discount_from')}
              value={_.get(formData, 'discount_from') || ''}
            />
          </div>
          <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext">
              Discount To {validateForm.renderMessage('discount_to')}
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('discount_to')}
              value={_.get(formData, 'discount_to') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button 
            type="submit" 
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  // createInput: PropTypes.instanceOf(Function).isRequired,
  getDiscountList: PropTypes.instanceOf(Function).isRequired,
  createDiscount: PropTypes.instanceOf(Function).isRequired,
  // formData: PropTypes.instanceOf(Object).isRequired,
  // setFormData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleDiscount: PropTypes.instanceOf(Function).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList: _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
